var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_386)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9419 0.280912C31.2641 0.0968256 31.6289 0 32 0C32.3711 0 32.7359 0.0968256 33.0581 0.280912L62.9248 17.3476C63.2513 17.5341 63.5227 17.8036 63.7116 18.1288C63.9004 18.454 63.9999 18.8233 64 19.1993V22.2713C64.0001 31.6835 60.9339 40.8394 55.2654 48.3532C49.597 55.867 41.6349 61.3296 32.5845 63.914C32.2024 64.0228 31.7976 64.0228 31.4155 63.914C22.3651 61.3296 14.403 55.867 8.73458 48.3532C3.06613 40.8394 -0.000117288 31.6835 3.36489e-09 22.2713L3.36488e-09 19.1993C0.000121292 18.8233 0.099632 18.454 0.28845 18.1288C0.477268 17.8036 0.748685 17.5341 1.0752 17.3476L30.9419 0.280912ZM30.1739 45.6996L48.5973 22.6638L45.2693 20.0014L29.5595 39.6324L18.432 30.3609L15.7013 33.6377L30.1739 45.6996Z",
    fill: "#22C55D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSuccess);
export default __webpack_public_path__ + "static/media/email_success.3816ed21d6ef8332575fc8c034b2523b.svg";
export { ForwardRef as ReactComponent };